import React, { useEffect } from 'react';
import { app, App } from '@starflow/app';
import { ErrorBoundary } from 'react-error-boundary';
import { isOverseas } from '@shakkerai/pro-utils';
import { initHowxm, identifyHowxm } from 'howxm-js';
import { useUserInfo } from '@starflow/app/store';
import { mv } from '@shakkerai/report';

export default function Project() {
  useEffect(() => {
    app.helpers.user.initUserInfo();
    app.helpers.cloud.initProjectData();
    app.helpers.cloud.initProjectDataPersist();
  }, []);

  function FallbackComponent({ error, resetErrorBoundary }) {
    useEffect(() => {
      try {
        if (error) {
          const msg = error?.message || '自定义异常，最顶层error bound捕获到的数据';
          mv('tool.exception', {
            event: 'painter.canvas.crash',
            level: 'fatal',
            msg: msg,
            traceback: error?.stack || '',
          });
          const ArmsRum = window?.RumSDK?.default;
          if (ArmsRum?.sendException) {
            ArmsRum.sendException({
              // 必选
              name: 'customProRootError',
              message: msg,
              // 可选
              file: '/pro',
              stack: error?.stack || '',
              // line: 1,
              // column: 2,
              // properties: {
              //   prop_msg: 'custom msg',
              //   prop_num: 1,
              // },
            });
          }
        }

        console.error(error);
      } catch (error) {
        console.error('armsRum sendException error:', error);
      }
    }, [error]);

    return (
      <div role="alert" className="w-[100vw] h-[100vh] flex justify-center items-center">
        <div>
          <p className="text-center text-lg font-semibold mb-4">
            {!isOverseas
              ? '非常抱歉，应用运行遇到异常，刷新页面或者点击下面“重试”按钮'
              : 'sorry, application error, please click Retry button'}
          </p>
          {/* <pre>{error.message}</pre> */}
          <p className="text-center">
            <button onClick={resetErrorBoundary} className="px-5 py-2 rounded-lg bg-[#ccc] cursor-pointer">
              {!isOverseas ? '重试' : 'Retry'}
            </button>
          </p>
        </div>
      </div>
    );
  }

  const { userInfo } = useUserInfo();
  const howxmKey = {
    'www-test.xingliu.art': 'deee60d8-e3c7-4c24-b702-906a87e62e65',
    'www.xingliu.art': '168e73eb-379e-4479-a621-d3d0ef8cd1b5',
    'www.shakker.ai': 'bd187ff3-4ba9-4f87-903c-65c4605c6b95',
  };
  useEffect(() => {
    initHowxm(howxmKey[window.location.hostname], console.info);

    if (userInfo) {
      identifyHowxm({
        uid: userInfo?.uuid, // 用户唯一ID, 默认字段, 必填，string 类型
        name: userInfo?.nickname, // 名称，默认字段，非必填，string 类型
        mobile: userInfo.mobile, // 手机号，默认字段，非必填，string类型，会进行校验
        email: userInfo.email, //
      });
    }

    // 延时一下，等howxm初始化完成
    // setTimeout(() => {
    //   eventHowxm('xingliutest', {});
    // }, 1000);
  }, [userInfo]);

  return (
    <div className="w-full h-screen relative bg-[#f1f2f3]">
      <ErrorBoundary
        FallbackComponent={FallbackComponent}
        onReset={() => {
          window.location.reload();
        }}
        resetKeys={['proTopErrorKey']}
      >
        <App />
      </ErrorBoundary>
    </div>
  );
}
